<div *ngIf="loaderState.loading" class="cssload-container">
  <div class="cssload-speeding-wheel">
    <div class="image-container">
      <img *ngIf="!loaderState.showGenericSpinner" src="../../../../assets/gifs/logo-loading.gif" alt="Loading..."
        height="60.19px" width="107px" />
      <img *ngIf="loaderState.showGenericSpinner" src="../../../../assets/gifs/loading-spinner.gif" alt="Loading..."
        width="107px" />
    </div>


    <p class="loading-description" *ngIf="loaderState.loadingMessageKey">
      {{'LOADING_DESCRIPTION.' + loaderState.loadingMessageKey | translate}}
    </p>

  </div>
</div>